$(document).ready(function() {
  setTimeout(function () {
    initParallax();
  }, 100);
    initGallery();
});


function initParallax() {
  lax.setup({
    breakpoints: { small: 0, phone:566, tablet: 768, large: 1023 }
  })
  const updateLax = () => {
    lax.update(window.scrollY)
    window.requestAnimationFrame(updateLax)

  }
  let w = window.innerWidth
  window.addEventListener("resize", function() {
    if(w !== window.innerWidth) {
      lax.updateElements()
    }
  });
  window.requestAnimationFrame(updateLax)
}


document.addEventListener("DOMContentLoaded", function () {
  var mySwiper = new Swiper(".sustainability-gallery-description", {
    autoHeight: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 500,
    direction: "horizontal",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar"
    },
    loop: false,
    effect: "slide",
    spaceBetween: 30,
    on: {
      init: function () {
        var customPagination = document.querySelectorAll(".swiper-pagination-custom .swiper-pagination-switch");
        customPagination.forEach(function (el) {
          el.classList.remove("active");
        });
        if (customPagination[0]) customPagination[0].classList.add("active");
      },
      slideChangeTransitionStart: function () {
        var customPagination = document.querySelectorAll(".swiper-pagination-custom .swiper-pagination-switch");
        customPagination.forEach(function (el) {
          el.classList.remove("active");
        });
        if (customPagination[mySwiper.realIndex]) {
          customPagination[mySwiper.realIndex].classList.add("active");
        }
      }
    }
  });

  var paginationSwitches = document.querySelectorAll(".swiper-pagination-custom .swiper-pagination-switch");
  paginationSwitches.forEach(function (el, index) {
    el.addEventListener("click", function () {
      mySwiper.slideTo(index);
      paginationSwitches.forEach(function (el) {
        el.classList.remove("active");
      });
      el.classList.add("active");
    });
  });
});
function initGallery() {
//  var sustainabilityGallery = new Swiper('.sustainability-gallery-description', {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   watchOverflow: true,
//   loop: false,
//   speed: 800,
//   pagination: {
//     el: '.sustainability-gallery-description .swiper-pagination',
//     type: 'progressbar',
//   },
//   breakpoints: {
//     768: {
//       pagination: {
//         el: '.sustainability-gallery-description .swiper-pagination',
//         type: 'fraction',
//         clickable: true,
//         formatFractionCurrent: function (number) {
//           return number < 10 ? '0' + number : number;
//         },
//         formatFractionTotal: function (number) {
//           return number < 10 ? '0' + number : number;
//         },
//       },
//     }
//   },
//   scrollbar: {
//     el: '.sustainability-gallery-description .swiper-scrollbar',
//     draggable: true,
//   },
//   navigation: {
//     nextEl: '.sustainability-gallery-description .swiper-button-next',
//     prevEl: '.sustainability-gallery-description .swiper-button-prev',
//   },
// });





  
  var sustainabilityGalleryFull = new Swiper ('.sustainability-gallery-description--full', {
    slidesPerView: '1',
    spaceBetween: 0,
    watchSlidesVisibility: false,
    watchSlidesProgress: true,
    watchOverflow: true,
    loop: false,
    speed: 800,
    pagination: {
      el: '.swiper-slider',
      type: 'progressbar',
    },
    breakpoints: {
      768: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
          formatFractionCurrent: function(number) {
            if (number < 10) {
            number = '0' + number;
            }
            return number;
          },
          formatFractionTotal: function(number) {
            if (number < 10) {
            number = '0' + number;
            }
            return number;
          },
        },
      },
      1200: {
        slidesPerView: '1.059',
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
          formatFractionCurrent: function(number) {
            if (number < 10) {
            number = '0' + number;
            }
            return number;
          },
          formatFractionTotal: function(number) {
            if (number < 10) {
            number = '0' + number;
            }
            return number;
          },
        },
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  var sustainabilitySlider = new Swiper ('.sustainability-slider', {
    slidesPerView: '1.4163',
    spaceBetween: 22,
    watchOverflow: true,
    loop: false,
    speed: 800,
    pagination: {
      el: '.swiper-slider',
      type: 'progressbar',
    },
    breakpoints: {
      576: {
        slidesPerView: '2.3',
        spaceBetween: 22,
        pagination: {
          el: '.swiper-slider',
          type: 'progressbar',
        },
      },
      768: {
        slidesPerView: '2.3',
        spaceBetween: 22,
        pagination: {
          el: '.swiper-slider',
          type: 'progressbar',
        },
      },
      1024: {
        spaceBetween: 40,
        slidesPerView: '3.18',
        pagination: {
          el: '.swiper-slider',
          type: 'progressbar',
        },
      },
      1200: {
        spaceBetween: 40,
        slidesPerView: '3.18',
        pagination: {
          el: '.swiper-slider',
          type: 'progressbar',
        },
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
